import { useCallback } from "react";
import { Linking, Platform } from "react-native";

import { useCreateBillingPortalSession } from "@/api/generated";
import { useGetUserProfile } from "@/api/queries/";
import { Button, Heading, Paragraph, Separator, YStack } from "@/components";
import { captureException } from "@/sentry";

export default function ManageBilling() {
  const { data } = useGetUserProfile();
  const { mutateAsync: createPortalSession, isPending } =
    useCreateBillingPortalSession();

  const openPortal = useCallback(async () => {
    try {
      // Portal URLs are single-use, so mint one per press rather than prefetching on render.
      const { url } = await createPortalSession();
      if (Platform.OS === "web") {
        window.location.assign(url);
      } else {
        Linking.openURL(url);
      }
    } catch (error) {
      captureException("Failed to open billing portal", { extra: { error } });
    }
  }, [createPortalSession]);

  if (!data?.stripeCustomerId) return null;

  return (
    <>
      <Separator borderColor="$fillNeutral" marginVertical="$250" />
      <YStack gap="$200">
        <Heading size="$sm">Billing</Heading>
        <Paragraph size="$sm" color="$textSecondary">
          Manage your payment method and subscription on Stripe.
        </Paragraph>
        <Button
          mode="secondary"
          alignSelf="flex-start"
          loading={isPending}
          onPress={openPortal}
          dataTrackingId="manage-billing"
        >
          Manage billing
        </Button>
      </YStack>
    </>
  );
}
